"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DEV = {
  apiKey: "AIzaSyBDIXqDicbzJF8FbhgCah5B4WkzDBXeRaY",
  authDomain: "codb-dev.firebaseapp.com",
  databaseURL: "https://codb-dev.firebaseio.com",
  projectId: "codb-dev",
  storageBucket: "codb-dev.appspot.com",
  messagingSenderId: "348364893514"
};
var _PROD = {
  apiKey: "AIzaSyBKgNPXYNokNjedb2LHJqk1D-3ixVjPjHI",
  authDomain: "codbio.firebaseapp.com",
  databaseURL: "https://codbio.firebaseio.com",
  projectId: "codbio",
  storageBucket: "codbio.appspot.com",
  messagingSenderId: "794765460933",
  appId: "1:794765460933:web:08cab3ca744dfc14"
};
exports.default = _PROD;
exports.CN_GROUP = 'groups';
exports.CN_ITEMS = 'items';
exports.CN_USERS = 'users';
exports.CN_FOLLOWED_GROUPS = 'followed_groups';
exports.CN_FOLLOWED_ITEMS = 'followed_items';
exports.CN_PUSH_TOKENS = 'push_tokens';
exports.CN_DELETED_ITEMS = 'deleted_items';
exports.GROUPS_FECTH_LIMIT = 20;
exports.ITEMS_FETCH_LIMIT = 9999;
exports.FOLLOWED_GROUPS_FETCH_LIMIT = 20;
exports.FOLLOWED_ITEMS_FETCH_LIMIT = 20;
exports.SEARCH_GROUPS_DEFAULT_LIST_LIMIT = 15;
exports.WAITING_HANDLE_ITEMS_FETCH_LIMIT = 15;